__turbopack_context__.v({
  "animated-group--active": "Uh5oKa_animated-group--active",
  "animated-group__animation": "Uh5oKa_animated-group__animation",
  "animated-group__animation--delay-1200": "Uh5oKa_animated-group__animation--delay-1200",
  "animated-group__animation--delay-1500": "Uh5oKa_animated-group__animation--delay-1500",
  "animated-group__animation--delay-1800": "Uh5oKa_animated-group__animation--delay-1800",
  "animated-group__animation--delay-2100": "Uh5oKa_animated-group__animation--delay-2100",
  "animated-group__animation--delay-2700": "Uh5oKa_animated-group__animation--delay-2700",
  "animated-group__animation--delay-300": "Uh5oKa_animated-group__animation--delay-300",
  "animated-group__animation--delay-3000": "Uh5oKa_animated-group__animation--delay-3000",
  "animated-group__animation--delay-3300": "Uh5oKa_animated-group__animation--delay-3300",
  "animated-group__animation--delay-3900": "Uh5oKa_animated-group__animation--delay-3900",
  "animated-group__animation--delay-600": "Uh5oKa_animated-group__animation--delay-600",
  "animated-group__animation--delay-900": "Uh5oKa_animated-group__animation--delay-900",
  "animated-group__animation--draw-path": "Uh5oKa_animated-group__animation--draw-path",
  "animated-group__animation--duration-1400": "Uh5oKa_animated-group__animation--duration-1400",
  "animated-group__animation--duration-300": "Uh5oKa_animated-group__animation--duration-300",
  "animated-group__animation--duration-600": "Uh5oKa_animated-group__animation--duration-600",
  "animated-group__animation--fade-in": "Uh5oKa_animated-group__animation--fade-in",
  "animated-group__animation--slide-up-16": "Uh5oKa_animated-group__animation--slide-up-16",
  "animated-group__animation--slide-up-40": "Uh5oKa_animated-group__animation--slide-up-40",
  "animated-group__animation--slide-up-8": "Uh5oKa_animated-group__animation--slide-up-8",
  "animated-group__animation--slide-up-bounce": "Uh5oKa_animated-group__animation--slide-up-bounce",
  "animated-group__animation--slide-up-eighth": "Uh5oKa_animated-group__animation--slide-up-eighth",
  "animated-group__animation--slide-up-half": "Uh5oKa_animated-group__animation--slide-up-half",
  "animated-group__animation--slide-up-quarter": "Uh5oKa_animated-group__animation--slide-up-quarter",
  "animated-group__transition": "Uh5oKa_animated-group__transition",
  "animated-group__transition--delay-1200": "Uh5oKa_animated-group__transition--delay-1200",
  "animated-group__transition--delay-2400": "Uh5oKa_animated-group__transition--delay-2400",
  "animated-group__transition--delay-3600": "Uh5oKa_animated-group__transition--delay-3600",
  "animated-group__transition--delay-600": "Uh5oKa_animated-group__transition--delay-600",
  "animated-group__transition--duration-300": "Uh5oKa_animated-group__transition--duration-300",
  "animated-group__transition--grow-height": "Uh5oKa_animated-group__transition--grow-height",
  "animated-group__transition--grow-width": "Uh5oKa_animated-group__transition--grow-width",
  "animated-group__transition--max-height-0-lg": "Uh5oKa_animated-group__transition--max-height-0-lg",
  "draw-path": "Uh5oKa_draw-path",
  "fade-in": "Uh5oKa_fade-in",
  "slide-up-16": "Uh5oKa_slide-up-16",
  "slide-up-40": "Uh5oKa_slide-up-40",
  "slide-up-8": "Uh5oKa_slide-up-8",
  "slide-up-bounce": "Uh5oKa_slide-up-bounce",
  "slide-up-eighth": "Uh5oKa_slide-up-eighth",
  "slide-up-half": "Uh5oKa_slide-up-half",
  "slide-up-quarter": "Uh5oKa_slide-up-quarter",
});
